/**
 * CSV helpers shared by every screen that writes a spreadsheet file (AB#6872).
 *
 * PURE module: no React, MUI, axios or auth imports.
 */

/** A leading character Excel and Sheets read as the start of a formula. */
const FORMULA_START = /^[-=+@\t\r]/;

/**
 * Neutralises CSV formula injection: text starting with `=`, `+`, `-`, `@`, a tab or a
 * carriage return is executed as a formula when the file is opened in Excel or Sheets, so
 * it is prefixed with an apostrophe (which Excel hides on display). Anything else comes
 * back unchanged. Use it on free text only: a negative number legitimately starts with '-'.
 */
export function escapeCsvFormula(text: string): string {
  return FORMULA_START.test(text) ? `'${text}` : text;
}
